import { Close, EmergencyHomeFilled, InfoFilled, CheckCircleFilled, WarningFilled } from '@interhyp/platform-icons';
import classnames from 'classnames';
import React from 'react';
import { IconRenderer } from "../../helper/components/IconRenderer.js";
import { Button } from "../button/index.js";
import { IconButton } from "../iconButton/IconButton.js";
import { Typography } from "../typography/Typography.js";
import styles from "./Notification.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const icons = {
  error: /*#__PURE__*/_jsx(EmergencyHomeFilled, {
    className: styles.statusIcon
  }),
  hint: /*#__PURE__*/_jsx(WarningFilled, {
    className: styles.statusIcon
  }),
  success: /*#__PURE__*/_jsx(CheckCircleFilled, {
    className: styles.statusIcon
  }),
  info: /*#__PURE__*/_jsx(InfoFilled, {
    className: styles.statusIcon
  })
};
const style = {
  error: styles.error,
  hint: styles.hint,
  info: styles.info,
  success: styles.success
};
export const Notification = ({
  className,
  children,
  onDismiss,
  dismissible = false,
  title,
  type = 'info',
  actions = [],
  ...rest
}) => {
  const classes = classnames(styles.notification, style[type], {
    [styles.empty]: !children,
    [styles.dismissible]: dismissible
  }, className);
  return /*#__PURE__*/_jsxs("div", {
    className: classes,
    ...rest,
    children: [icons[type], /*#__PURE__*/_jsxs("div", {
      className: styles.content,
      children: [title && /*#__PURE__*/_jsx(Typography, {
        className: styles.title,
        variant: "h5",
        margin: false,
        children: title
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.text,
        children: [children, actions.length > 0 && /*#__PURE__*/_jsx("div", {
          className: styles.actionButtons,
          children: actions.map(action => /*#__PURE__*/_jsx(Button, {
            onClick: action.onClick,
            variant: "text",
            process: true,
            children: /*#__PURE__*/_jsxs("span", {
              className: styles.actionButtonContent,
              children: [/*#__PURE__*/_jsx(IconRenderer, {
                icon: action.icon
              }), action.title]
            })
          }, action.title))
        })]
      })]
    }), dismissible && /*#__PURE__*/_jsx("span", {
      className: styles.dismissIcon,
      children: /*#__PURE__*/_jsx(IconButton, {
        onClick: onDismiss,
        className: styles.dismissIconButton,
        tertiary: true,
        children: /*#__PURE__*/_jsx(Close, {})
      })
    })]
  });
};